import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function TrashIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="17.359" height="19.697" viewBox="0 0 17.359 19.697" {...props}>
      <g id="Group_6266" data-name="Group 6266" transform="translate(-927.284 -929.654)">
        <path id="Path_6488" data-name="Path 6488" d="M942.076,947.089a2.077,2.077,0,0,1-1.914,1.965c-1.056.1-2.411.193-3.632.193-1.293,0-2.747-.1-3.863-.2a2.074,2.074,0,0,1-1.911-1.965L930.28,934.6h12.272Z" transform="translate(-0.452 -0.896)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <line id="Line_481" data-name="Line 481" x2="15.359" transform="translate(928.284 933.649)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <path id="Path_6489" data-name="Path 6489" d="M938.214,930.648" transform="translate(-2.251)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <g id="Group_5974" data-name="Group 5974" transform="translate(933.966 937.138)">
          <line id="Line_482" data-name="Line 482" y2="7.024" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          <line id="Line_483" data-name="Line 483" y2="7.024" transform="translate(3.994)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        </g>
        <path id="Path_6490" data-name="Path 6490" d="M935.239,932.96v-2.3h4.6v2.3" transform="translate(-1.576 -0.002)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </SvgIcon>
  );
} 

export default TrashIcon;



// WEBPACK FOOTER //
// ./src/components/icons/TrashIcon.jsx